/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import React from 'react';
import { Heading, Modal, Size } from '@vaisala-rockhopper/components';
import { HelpModal } from './HelpModal';
import { OptionsModal, OptionsConfig, OptionsModalProps } from './OptionsModal';
import InstallPWAModal from './InstallPWAModal';
import './Modals.scss';
import ShareModal from './ShareModal';
import ContactModal from './ContactModal';

export type ModalType = 'modal.help' | 'modal.options' | 'modal.pwa' | `modal.${string}` | '';

export interface ModalProps {
  currentModal: ModalType;
  onCloseModal: VoidFunction;
  theme: string;
  title?: string;
  onAccept?: VoidFunction;
  onReject?: VoidFunction;
  optionsConfig?: OptionsConfig;
}

export interface ModalInstanceProps extends ModalProps {
  modalId: ModalType;
  children: React.ReactNode;
  theme: string;
  size?: Size.S | Size.M | Size.L;
}

export const ModalInstance = (props: ModalInstanceProps) => {
  const { currentModal, onCloseModal, theme, modalId, title, size } = props;
  return (
    <Modal
      className={`indigo-selector modal modal--${theme} modal--${modalId.split('.')[1]}`}
      isOpen={currentModal === modalId}
      width={size ?? Size.S}
      showCloseIcon
      onDismiss={onCloseModal}
    >
      <Heading level={2} className="vai-margin-top-none">
        {title}
      </Heading>
      {props.children}
    </Modal>
  );
};

export const Modals = (props?: ModalProps) => {
  //  when a modal is opened, prevent page scrolling on mobile
  React.useEffect(() => {
    document.body.style.overflow = props && props.currentModal ? 'hidden' : '';
  }, [props]);

  return (
    <>
      {props && (
        <>
          {props.currentModal === 'modal.help' && <HelpModal {...props} />}
          {props.currentModal === 'modal.options' && <OptionsModal {...(props as OptionsModalProps)} />}
          {props.currentModal === 'modal.pwa' && <InstallPWAModal {...props} />}
          {props.currentModal === 'modal.share' && <ShareModal {...props} />}
          {props.currentModal === 'modal.contact' && <ContactModal {...props} />}
        </>
      )}
    </>
  );
};
